import posthog from 'posthog-js';
import React from 'react';
import { createRoot } from 'react-dom/client';

import Router from '@dashboard/Router';

if (WAYPOINT_CONFIGURATION.posthogProjectKey) {
  posthog.init(WAYPOINT_CONFIGURATION.posthogProjectKey, { api_host: 'https://app.posthog.com' });
}

const container = document.getElementById('body');
if (!container) {
  throw new Error('No container found');
}
createRoot(container).render(<Router />);
